module.exports = __webpack_public_path__ + "img/5-text.6d9db2fc.png";